import React from 'react';

export const DropSvg = (props) => {

  const { width, height, color } = props;

  if (color) {
    return (
      <svg width={width ?? "36"} height={height ?? "36"} viewBox="0 0 25 36" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M22.6949 17.7057L11.8707 0L1.8405 17.5847C-0.495063 21.3109 -0.698893 26.1562 1.75451 30.1691C5.24193 35.8732 12.7561 37.7045 18.5398 34.2638C24.3214 30.8241 26.1824 23.414 22.6949 17.7057Z" fill={color} />
      </svg>
    )
  }

  return (
    <svg width={width ?? "36"} height={height ?? "36"} viewBox="0 0 25 36" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M22.6949 17.7057L11.8707 0L1.8405 17.5847C-0.495063 21.3109 -0.698893 26.1562 1.75451 30.1691C5.24193 35.8732 12.7561 37.7045 18.5398 34.2638C24.3214 30.8241 26.1824 23.414 22.6949 17.7057Z" fill="#5DADEC" />
    </svg>
  )
}